import { Aside } from "../components/Aside";
import { CarouselEvents } from "../components/CarouselEvents";
import { Col } from "react-bootstrap";
import { Timeline } from "../components/Timeline";
import Alert from "@mui/material/Alert";
import { auth } from "../firebase/firebaseConfig";
import { useEffect, useState } from "react";
import { Footer } from "../components/Footer";

export const Home = () => {
    const [profile, setProfile] = useState({});

    useEffect(() => {
        const user = auth.currentUser;
        if (user) {
            setProfile(user);
        }
    }, []);

    return (
        <div>
            <div className="d-flex">
                <Col sm={9}>
                    <CarouselEvents marginTop={"63px"} />
                    <Timeline />
                </Col>
                <Col sm={3} className="position-fixed end-0">
                    <Aside />
                </Col>
            </div>
            <Footer />
        </div>
    );
};
